<template>
  <div class="about-page">
      <!-- 1. Hero Section -->
      <nav class="navbar navbar-expand-lg navbar-light bg-white shadow-sm sticky-top">
            <div class="container">
                <a class="navbar-brand fw-bold text-success" href="#">
                    <i class="fas fa-quran me-2"></i>مسابقة تارجت
                </a>
                <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
                    aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>
                <div class="collapse navbar-collapse" id="navbarNav">
                    <ul class="navbar-nav mx-auto">
                        <li class="nav-item">
                            <a class="nav-link" href="/">الصفحة الرئيسية</a>
                        </li>
                        <!-- <li class="nav-item">
                            <a class="nav-link" href="/">الجوائز</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" href="#partners">الرعاة</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" href="/AboutView">التعريف بالمسابقة</a>
                        </li> -->
                    </ul>
                    <router-link :to="{ name: 'Login' }" class="btn btn-outline-success">
                        <i class="fas fa-sign-in-alt me-2"></i>دخول المشترك
                    </router-link>
                </div>
            </div>
        </nav>
      <header class="about-hero text-center text-white d-flex align-items-center justify-content-center mb-5">
          <div class="container" data-aos="fade-up">
              <h1 class="display-4 fw-bold">عن مسابقة تارجت</h1>
              <p class="lead my-3">
                  منصة رائدة لتشجيع حفظة كتاب الله وتكريمهم في بيئة تنافسية ملهمة.
              </p>
          </div>
      </header>

      <div class="container">
          <!-- 2. Our Vision & Goals -->
          <section id="our-vision" class="py-5">
              <div class="row align-items-center">
                  <div class="col-lg-6" data-aos="fade-left">
                      <img :src="'/img/logo/bg.jpg'" alt="رؤيتنا" class="img-fluid rounded shadow-lg">
                      <!-- ضع صورة مناسبة في public/img/about-vision.jpg -->
                  </div>
                  <div class="col-lg-6" data-aos="fade-right">
                      <h2 class="section-title text-end"><span>رؤيتنا وأهدافنا</span></h2>
                      <p class="lead">
                          نسعى في "مسابقة تارجت" إلى أن نكون منارة لخدمة القرآن الكريم وأهله، عبر إيجاد بيئة إيمانية تحتفي بحفظة كتاب الله وتبرز مواهبهم.
                      </p>
                      <div class="list-group list-group-flush mt-4">
                          <div class="list-group-item border-0 d-flex align-items-start">
                              <i class="fas fa-bullseye fa-fw text-success fs-4 me-3"></i>
                              <div>
                                  <h5 class="mb-1">تشجيع الحفظ والإتقان</h5>
                                  <p class="mb-0 text-muted">بث روح التنافس الشريف بين أبنائنا لحفظ القرآن وتجويده.</p>
                              </div>
                          </div>
                          <div class="list-group-item border-0 d-flex align-items-start">
                              <i class="fas fa-seedling fa-fw text-success fs-4 me-3"></i>
                              <div>
                                  <h5 class="mb-1">نشر القيم القرآنية</h5>
                                  <p class="mb-0 text-muted">ترسيخ الأخلاق والقيم المستمدة من القرآن في نفوس المشاركين.</p>
                              </div>
                          </div>
                          <div class="list-group-item border-0 d-flex align-items-start">
                              <i class="fas fa-search-plus fa-fw text-success fs-4 me-3"></i>
                              <div>
                                  <h5 class="mb-1">اكتشاف المواهب</h5>
                                  <p class="mb-0 text-muted">إبراز الأصوات الندية والمواهب الفذة في التلاوة ورعايتها.</p>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </section>

          <!-- 3. Conditions -->
          <section id="conditions" class="py-5 bg-light rounded-3">
               <h2 class="text-center mb-5 section-title" data-aos="fade-up"><span>شروط الاشتراك</span></h2>
               <ul class="list-unstyled row text-center">
                  <li class="col-md-6 col-lg-4 mb-3" data-aos="fade-up" data-aos-delay="100">
                      <div class="card h-100 p-3"><i class="fas fa-flag fa-2x text-success mb-2"></i> أن يكون المتقدم مصري الجنسية.</div>
                  </li>
                   <li class="col-md-6 col-lg-4 mb-3" data-aos="fade-up" data-aos-delay="200">
                      <div class="card h-100 p-3"><i class="fas fa-user-check fa-2x text-success mb-2"></i> الالتزام بالمستوى الذي تم اختياره.</div>
                  </li>
                   <li class="col-md-6 col-lg-4 mb-3" data-aos="fade-up" data-aos-delay="300">
                      <div class="card h-100 p-3"><i class="fas fa-trophy fa-2x text-success mb-2"></i> ألا يكون قد فاز بنفس المستوى سابقًا.</div>
                  </li>
               </ul>
          </section>
          
          <!-- 4. Competition Stages (Timeline) -->
          <section id="stages" class="py-5">
              <h2 class="text-center mb-5 section-title" data-aos="fade-up"><span>مراحل المسابقة</span></h2>
              <div class="timeline-container">
                  <div class="timeline-item" data-aos="fade-up">
                      <div class="timeline-content">
                          <h5>المرحلة الأولى: التسجيل</h5>
                          <p>فتح باب التسجيل الإلكتروني عبر الموقع واختيار مستوى المسابقة.</p>
                      </div>
                  </div>
                  <div class="timeline-item" data-aos="fade-up">
                      <div class="timeline-content">
                          <h5>المرحلة الثانية: التصفيات الأولية</h5>
                          <p>إجراء اختبارات أولية لجميع المتقدمين في المناطق المحددة.</p>
                      </div>
                  </div>
                  <div class="timeline-item" data-aos="fade-up">
                      <div class="timeline-content">
                          <h5>المرحلة الثالثة: التصفيات النهائية</h5>
                          <p>دعوة المتأهلين من المرحلة الأولية للمنافسة في الاختبارات النهائية.</p>
                      </div>
                  </div>
                  <div class="timeline-item" data-aos="fade-up">
                      <div class="timeline-content">
                          <h5>المرحلة الرابعة: الحفل الختامي</h5>
                          <p>تكريم الفائزين وتسليم الجوائز في حفل بهيج بحضور الرعاة والجمهور.</p>
                      </div>
                  </div>
              </div>
          </section>

          <!-- 5. FAQ Section -->
          <section id="faq" class="py-5">
              <h2 class="text-center mb-5 section-title" data-aos="fade-up"><span>أسئلة شائعة</span></h2>
              <div class="accordion" id="faqAccordion" data-aos="fade-up">
                  <div class="accordion-item" v-for="(faq, index) in faqs" :key="index">
                      <h2 class="accordion-header" :id="'heading' + index">
                          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" :data-bs-target="'#collapse' + index" aria-expanded="false" :aria-controls="'collapse' + index">
                              {{ faq.question }}
                          </button>
                      </h2>
                      <div :id="'collapse' + index" class="accordion-collapse collapse" :aria-labelledby="'heading' + index" data-bs-parent="#faqAccordion">
                          <div class="accordion-body">
                              {{ faq.answer }}
                          </div>
                      </div>
                  </div>
              </div>
          </section>
      </div>
  </div>
</template>

<script>
export default {
  name: 'AboutPage',
  data() {
      return {
          faqs: [
              {
                  question: 'كيف يتم حساب الدرجات النهائية؟',
                  answer: 'يتم حساب الدرجة النهائية بناءً على مجموع درجات الحفظ (60%)، التجويد (30%)، وحسن الأداء وجمال الصوت (10%). لجنة التحكيم هي صاحبة القرار النهائي.'
              },
              {
                  question: 'هل يمكنني تغيير مستوى الاشتراك بعد التسجيل؟',
                  answer: 'لا، بمجرد تأكيد التسجيل لا يمكن تغيير مستوى المسابقة. يرجى اختيار المستوى الذي يناسب قدراتك بدقة قبل تأكيد التسجيل.'
              },
              {
                  question: 'ماذا لو تخلفت عن موعد الاختبار الأولي؟',
                  answer: 'التخلف عن موعد الاختبار دون عذر قهري تقبله اللجنة المنظمة يعني استبعاد المتسابق تلقائيًا من المسابقة. يرجى الحرص على الالتزام بالموعد المحدد.'
              },
              {
                  question: 'هل هناك جوائز لغير الفائزين بالمراكز الأولى؟',
                  answer: 'نعم، بالإضافة إلى الجوائز المالية الكبرى، سيتم تقديم شهادات تقدير وجوائز عينية تشجيعية للمتميزين الذين لم يحالفهم الحظ في الفوز بالمراكز الأولى.'
              }
          ]
      }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Cairo:wght@400;700&display=swap');

.about-page {
  font-family: 'Cairo', sans-serif;
}

/* Hero Section */
.about-hero {
  position: relative;
  height: 40vh;
  background: linear-gradient(rgba(25, 135, 84, 0.7), rgba(0, 50, 20, 0.8)), url('/public/img/logo/bg.jpg') no-repeat center center;
  background-size: cover;
  border-radius: 0 0 15px 15px;
}

/* Section Title */
.section-title {
  position: relative;
  padding-bottom: 15px;
  margin-bottom: 2rem;
  color: #2c3e50;
  font-weight: 700;
}
.section-title::after {
  content: '';
  position: absolute;
  display: block;
  width: 60px;
  height: 4px;
  background: #198754;
  bottom: 0;
  /* Adjust for text-end */
  right: 0;
}
.text-center.section-title::after {
  left: 50%;
  transform: translateX(-50%);
  right: auto;
}

/* Timeline */
.timeline-container {
  position: relative;
  padding: 2rem 0;
}
.timeline-container::before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  width: 4px;
  background: #e9ecef;
  right: 20px; /* For RTL */
}
.timeline-item {
  position: relative;
  margin-bottom: 50px;
  padding-right: 50px; /* For RTL */
}
.timeline-item::before { /* The circle on the timeline */
  content: '';
  position: absolute;
  top: 0;
  right: 10px; /* For RTL */
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background: white;
  border: 4px solid #198754;
  z-index: 1;
}
.timeline-content {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  border: 1px solid #e9ecef;
  box-shadow: 0 4px 10px rgba(0,0,0,0.05);
}

/* FAQ Accordion */
.accordion-button {
  font-weight: 600;
  color: #2c3e50;
}
.accordion-button:not(.collapsed) {
  color: #fff;
  background-color: #198754;
}
.accordion-button:focus {
  box-shadow: 0 0 0 0.25rem rgba(25, 135, 84, 0.25);
}
</style>